export default __webpack_public_path__ + "static/media/banana.d6e80300.jpg";